import Highlighter from 'react-highlight-words';
import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "SuggestSearchstyle__Container",
  componentId: "sc-onvda2-0"
})(["", ""], {
  "marginTop": "2rem"
});
export const Wrapper = styled.div.withConfig({
  displayName: "SuggestSearchstyle__Wrapper",
  componentId: "sc-onvda2-1"
})(["", " grid-template-columns:100px calc(100% - 24px);@media (max-width:", "){", " grid-template-columns:auto;}"], {
  "marginBottom": "1.5rem",
  "display": "grid",
  "gap": "1.5rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginBottom": "2rem",
  "gap": "0.5rem"
});
export const Topic = styled.div.withConfig({
  displayName: "SuggestSearchstyle__Topic",
  componentId: "sc-onvda2-2"
})(["", " @media (max-width:", "){", "}"], {
  "textAlign": "right",
  "fontSize": "1.25rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(43 43 43 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "textAlign": "left"
});
export const SuggestText = styled.div.withConfig({
  displayName: "SuggestSearchstyle__SuggestText",
  componentId: "sc-onvda2-3"
})(["", " mark{", "}@media (max-width:", "){", "}"], {
  "display": "flex",
  "alignItems": "baseline",
  "gap": "0.75rem",
  "textOverflow": "ellipsis",
  "fontSize": "1.25rem",
  "lineHeight": "1.5rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(167 167 167 / var(--tw-text-opacity, 1))"
}, {
  "backgroundColor": "transparent",
  "padding": "0px",
  "--tw-text-opacity": "1",
  "color": "rgb(23 23 23 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gap": "0.5rem",
  "fontSize": "1.5rem",
  "lineHeight": "2rem"
});
export const SeeAll = styled.div.withConfig({
  displayName: "SuggestSearchstyle__SeeAll",
  componentId: "sc-onvda2-4"
})(["", " .text{", "}.icon{", "}@media (max-width:", "){.text{", "}}"], {
  "marginTop": "0.5rem",
  "display": "flex",
  "cursor": "pointer",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.25rem"
}, {
  "fontSize": "1rem",
  "lineHeight": "1rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
}, {
  "width": "0.75rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "21px",
  "fontWeight": "500",
  "lineHeight": "24px"
});
export const BulletCustom = styled.div.withConfig({
  displayName: "SuggestSearchstyle__BulletCustom",
  componentId: "sc-onvda2-5"
})(["", " img{", "}@media (max-width:", "){", " img{", "}}"], {
  "flexShrink": "0",
  "--tw-translate-y": "-30%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
}, {
  "aspectRatio": "1 / 1",
  "width": "0.375rem !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "--tw-translate-y": "-10%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
}, {
  "width": "0.625rem !important"
});
export const HighlighterCustom = styled(Highlighter).withConfig({
  displayName: "SuggestSearchstyle__HighlighterCustom",
  componentId: "sc-onvda2-6"
})(["span{", "}mark{", "}"], {
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(223 43 65 / var(--tw-text-opacity, 1))"
});